import { FolderType, FolderTypeValues } from 'modules/shared/models';

type RouteType = 1 | 2;
export const routes: { [key in RouteType]: { path: string; folderType: FolderType } } = {
    1: {
        path: 'prospect',
        folderType: FolderTypeValues.PROSPECT,
    },
    2: {
        path: 'client',
        folderType: FolderTypeValues.CUSTOMER,
    },
};
